"use client";
import "../../../chunk-MMUBH76A.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { CpslIcon } from "@getpara/react-components";
import { styled } from "styled-components";
import { useModalStore } from "../../stores/index.js";
import { useThemeStore } from "../../stores/theme/useThemeStore.js";
import { useGoBack } from "../../hooks/useGoBack.js";
import { AccountSelect, ChainSelect } from "./Selects.js";
import { ModalStep } from "../../utils/steps.js";
import { HeaderButton } from "@getpara/react-common";
const Controls = ({ onClose }) => {
  const bareModal = useThemeStore((state) => state.bareModal);
  const hasPreviousStep = useModalStore((state) => state.hasPreviousStep());
  const step = useModalStore((state) => state.step);
  const isFullyLoggedIn = useModalStore((state) => state.isFullyLoggedIn);
  const goBack = useGoBack();
  const shouldShowSelects = [
    ModalStep.ACCOUNT_MAIN,
    ModalStep.CHAIN_SWITCH,
    ModalStep.ADD_FUNDS_BUY,
    ModalStep.ADD_FUNDS_RECEIVE,
    ModalStep.ADD_FUNDS_WITHDRAW
  ].includes(step);
  const handleBackClick = () => {
    goBack();
  };
  return /* @__PURE__ */ jsxs(Container, { children: [
    /* @__PURE__ */ jsx(
      BackButton,
      {
        variant: "ghost",
        style: {
          visibility: hasPreviousStep ? "visible" : "hidden"
        },
        onClick: handleBackClick,
        children: /* @__PURE__ */ jsx(CpslIcon, { icon: "arrow" })
      }
    ),
    /* @__PURE__ */ jsx(MiddleContainer, { children: shouldShowSelects && isFullyLoggedIn && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(ChainSelect, {}),
      /* @__PURE__ */ jsx(AccountSelect, {})
    ] }) }),
    /* @__PURE__ */ jsx(CloseButton, { bareModal, variant: "ghost", onClick: onClose, children: /* @__PURE__ */ jsx(CpslIcon, { icon: "close" }) })
  ] });
};
const Container = styled.div`
  position: absolute;
  width: 100%;
  top: 16px;

  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;
const MiddleContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;
const CloseButton = styled(HeaderButton)`
  transform: rotate(180deg);
  visibility: ${({ bareModal }) => bareModal ? "hidden" : "visible"};
`;
const BackButton = styled(HeaderButton)`
  transform: rotate(180deg);
`;
export {
  Controls
};
